import type { SearchPage } from '@bulknutrients/bulk-shared-lib/interfaces/InformationPage';

import { SearchResultCardPage } from '../SearchResultCardPage';

export function PagesList({ data }: { data: SearchPage[] }) {
  return (
    <div className="ga-search-list ga-search-pages flex flex-col gap-2.5 pb-8">
      {data.map((d) => (
        <SearchResultCardPage key={d.slug} hit={d} />
      ))}
    </div>
  );
}
